export const email = /\S+@\S+\.\S+/;